import actionTypes from '../../actions/bill/preSettle/actionType';

const defaultPreSettleInfo = {
  consumedAmount: 0, // 已消费合计（未结）
  depositSum: 0, // 应付总押金（预结算）
  discountAmount: 0, // 优惠券抵扣
  lackAmount: 0, // 还需付房费
  lackDepositAmount: 0, // 还需付押金
  otaPayedAmount: 0, // OTA预付款
  payedAmount: 0, // 已付款（未结）
  payedDepositAmount: 0, // 已付押金
  sum: 0, // 应付总房费（预结算）
  resvNo: '', // 预订单号
};

const initialState = {
  drawerVisible: false,
  infoLoading: false,
  preSettleInfo: defaultPreSettleInfo,
  preSettleBizNo: '', // 业务单号
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_PRE_SETTLE_DRAWER_VISIBLE:
      const { drawerVisible } = payload;
      return {
        ...state,
        drawerVisible,
      };

    case actionTypes.SET_PRE_SETTLE_INFO_LOADING:
      const { infoLoading } = payload;
      return {
        ...state,
        infoLoading,
      };
    case actionTypes.FETCH_PRE_SETTLE_INFO:
      const { preSettleInfo } = payload;
      return {
        ...state,
        preSettleInfo,
      };
    case actionTypes.RESET_PRE_SETTLE_INFO:
      return {
        ...state,
        preSettleInfo: defaultPreSettleInfo,
      };

    case actionTypes.SET_PRE_SETTLE_BIZ_NO:
      const { preSettleBizNo } = payload;
      return {
        ...state,
        preSettleBizNo,
      };
    default:
      return state;
  }
};
